export default __webpack_public_path__ + "static/media/Patio-Season.2b48a240.jpg";